<template>
  <nav class="menu__nav">
    <ul class="menu-list" :class="[direction, theme]">
      <li
        class="menu-list__item"
        v-for="item in visibleNavigation"
        :key="item.path"
        :class="{active: $route.path.includes('agenda') && agendaRoute === item.path || $route.path.includes('ce-info') && ceRoute === item.path}"
      >
        <router-link :to="item.path"><i class="fa-regular" :class="item.icon"></i>{{ item.name }}  <span class="menu-count" v-if="item.name === 'My Schedule' && tabs.length && tabs[1].count">{{tabs[1].count}}</span></router-link>

      </li>
    </ul>
  </nav>
</template>

<script>
import { ROUTES } from "../../../router";
import {mapGetters} from 'vuex'
import touchDevice from "../../../mixins/touch-device";

export default {
  mixins: [touchDevice],
  props: [
    'direction',
    'theme'
  ],
  data() {
    return {
      agendaRoute: ROUTES.AGENDA_EVENT.replace(':attendeeId', this.$route.params.attendeeId),
      ceRoute: ROUTES.CE_INFO.replace(':attendeeId', this.$route.params.attendeeId),
      navigation: [],
    }
  },
  computed: {
    ...mapGetters('attendeeStore', ['isSingleSession', 'sidebarMenu',  'tabs', 'showMySchedule', 'hideCeInformation']),
  },
  watch: {
    sidebarMenu(val) {
      // event/schedule
      if (val) {
        if (this.isSingleSession) {
          this.navigation.push({
            name: 'Event',
            icon: 'fa-calendar-days',
            path: ROUTES.SINGLE_EVENT.replace(':attendeeId', this.$route.params.attendeeId)
          });
        } else {
          this.navigation.push({
            name: 'Schedule',
            icon: `fa-calendar-check`,
            path: ROUTES.AGENDA_EVENT.replace(':attendeeId', this.$route.params.attendeeId),
          });

          if (this.showMySchedule) {
            this.navigation.push({
              name: 'My Schedule',
              icon: `fa-square-heart`,
              path: ROUTES.AGENDA_SCHEDULE.replace(':attendeeId', this.$route.params.attendeeId),
            });
          }
        }
        // scan in/out
        if (this.sidebarMenu.scan_in_out) {
          this.navigation.push({
            name: 'Scan in/out',
            icon: 'fa-qrcode',
            path: ROUTES.SCAN_IN_OUT.replace(':attendeeId', this.$route.params.attendeeId),
            touchOnly: true,
          });
        }
        // speakers
        if (this.sidebarMenu.speakers && !this.isSingleSession) {
          this.navigation.push({
            name: 'Speakers',
            icon: 'fa-user',
            path: ROUTES.SPEAKERS.replace(':attendeeId', this.$route.params.attendeeId),
          });
        }
        // ce info/ce's
        if (this.isSingleSession) {
          this.navigation.push({
            name: this.hideCeInformation ? 'Info' : 'CE Info',
            icon: 'fa-briefcase',
            path: ROUTES.CE_INFO.replace(':attendeeId', this.$route.params.attendeeId),
          });
        } else {
          this.navigation.push({
            name: this.hideCeInformation ? 'Info' : "CEs",
            icon: 'fa-circle-info',
            path: ROUTES.CE_INFO.replace(':attendeeId', this.$route.params.attendeeId),
          });
        }

        // exhibit hall
        if (this.sidebarMenu.exhibit_hall) {
          this.navigation.push({
            name: 'Exhibit Hall',
            icon: 'fa-briefcase',
            path: ROUTES.EXHIBIT_HALL.replace(':attendeeId', this.$route.params.attendeeId),
          });
        }
        if (this.sidebarMenu.materials) {
          this.navigation.push({
            name: 'Materials',
            icon: 'fa-cube',
            path: ROUTES.EVENT_MATERIALS.replace(':attendeeId', this.$route.params.attendeeId),
          });
        }

      }
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>

.menu-count{
  background-color: rgb(255, 102, 102);
  font-size: 12px;
  height: 15px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 15px;
  border-radius: 15px;
  padding: 0 4px;
}

.menu-list {
  list-style: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  //margin: 0 -10px;
  padding-top: var(--attendee-gap-md) !important;

  width: 100%;

  &.light {
  }

  &.dark {
    li {
      a {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: var(--attendee-gap-md);
        color: white;
        align-items: center;
      }
    }
  }

  &.row {
    flex-direction: row;
  }

  &.column {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    //margin-top: 40px;
    .menu-list__item {
    }
  }

  &__item {
    width: 100%;
    //margin: 0 10px;
    transition: .3s all;
    position: relative;

    //&:first-child{
    //  padding-top: var(--attendee-gap-lg);
    //}

    &.active {
      background-color: #F3F6F9;
      a {
        color: var(--attendee-brand-color);
      }
    }

    a {
      padding: var(--attendee-gap-sm) var(--attendee-gap-lg);

      transition: .3s all;
      white-space: nowrap;
      text-decoration: none;
      font-weight: 400;
      color: var(--attendee-text-primary-color);
      //font-size: 19px;
      display: grid;
      grid-template-columns: auto 1fr auto;
      gap: var(--attendee-gap-md);
      align-items: center;
      font-size: 18px;

      @media (max-width: 1100px) {
        padding: var(--attendee-gap-sm) var(--attendee-gap-md);
        gap: 12px;
        font-size: 16px;
      }

      &.router-link-exact-active {
        color: var(--attendee-brand-color);
        background-color: #F3F6F9;
      }
    }

    &:hover {
      background-color: #F3F6F9;
      a {
        color: var(--attendee-brand-color);

        &:before {
          width: 100%;
        }
      }
    }
  }
}
</style>
